var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8SlideUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "144px",
    height: "144px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 9.858,
    y1: 9.858,
    x2: 38.142,
    y2: 38.142,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#99ddff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#268391"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,24c0,11.045 -8.955,20 -20,20c-11.045,0 -20,-8.955 -20,-20c0,-11.045 8.955,-20 20,-20c11.045,0 20,8.955 20,20z",
    fill: "url(#color-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,27.002c0,0.657 -0.215,1.319 -0.657,1.872c-1.035,1.294 -2.923,1.503 -4.217,0.469l-8.126,-6.501l-8.126,6.501c-1.294,1.035 -3.182,0.825 -4.217,-0.469c-1.035,-1.295 -0.824,-3.182 0.469,-4.217l10,-8c1.096,-0.876 2.652,-0.876 3.748,0l10,8c0.741,0.593 1.126,1.465 1.126,2.345z",
    fill: "#000000",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5,27.002c0,0.548 -0.179,1.099 -0.548,1.56c-0.863,1.078 -2.436,1.253 -3.514,0.39l-8.438,-6.751l-8.438,6.751c-1.078,0.863 -2.651,0.688 -3.514,-0.39c-0.863,-1.079 -0.687,-2.651 0.39,-3.514l10,-8c0.913,-0.73 2.21,-0.73 3.124,0l10,8c0.617,0.494 0.938,1.22 0.938,1.954z",
    fill: "#000000",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,27.001c0,0.438 -0.143,0.879 -0.438,1.248c-0.69,0.862 -1.948,1.002 -2.811,0.312l-8.75,-7l-8.75,7c-0.863,0.69 -2.121,0.55 -2.811,-0.312c-0.691,-0.863 -0.55,-2.121 0.312,-2.811l10,-8c0.73,-0.584 1.769,-0.584 2.499,0l10,8c0.492,0.395 0.749,0.977 0.749,1.563z",
    fill: "#ffffff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SlideUp);
export default __webpack_public_path__ + "static/media/icons8-slide-up.e5ab26a7d9bc4346e2510d93f15a1702.svg";
export { ForwardRef as ReactComponent };